import ResiduePage from './ResiduePage'

export default ResiduePage
